<template>
  <div class="row px-3">
    <div class="col-12 mb-4">
			<span class="back-btn" @click="$emit('setCurrentTab','PaymentDetailsForm')">
				<font-awesome-icon icon="arrow-left" size="sm" />
				Back
			</span>
    </div>

    <div class="col-12">
      <p>
        Please preview the details you've provided and scroll down to submit.
      </p>
      <div class="title-text font-weight-bold">
        Invoice details
      </div>
      <div class="row my-2">
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.PURCHASE_ORDER_NUMBER}}</div>
          <div>{{filteredFormData.poNumber}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.COMPANY_AND_CODE_NAME}}</div>
          <div>{{filteredFormData.companyCode}} - {{filteredFormData.companyCodeText}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.ONE_TIME_SUPPLIER_ID}}</div>
          <div>{{filteredFormData.supplierNumber}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.ONE_TIME_SUPPLIER_NAME}}</div>
          <div class="wrap-text">{{filteredFormData.supplierName}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.supplierTaxId">
          <div class="form-text">{{FORM_LABELS.SUPPLIER_TAX_ID}}</div>
          <div>{{filteredFormData.supplierTaxId}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.houseNumber">
          <div class="form-text">{{FORM_LABELS.HOUSE_NO_STREET_NAME}}</div>
          <div>{{filteredFormData.houseNumber}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.street">
          <div class="form-text">{{FORM_LABELS.STREET_NAME}} <span class="font-italic">{{FORM_LABELS.CONTINUED}}</span></div>
          <div>{{filteredFormData.street}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.city">
          <div class="form-text">{{FORM_LABELS.CITY}}</div>
          <div>{{filteredFormData.city}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="formattedState">
          <div class="form-text">{{FORM_LABELS.STATE}}</div>
          <div>{{formattedState}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.postalCode">
          <div class="form-text">{{FORM_LABELS.ZIP}}</div>
          <div>{{filteredFormData.postalCode}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="countryPreview">
          <div class="form-text">{{FORM_LABELS.COUNTRY}}</div>
          <div>{{countryPreview}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.PAYMENT_REQUEST_AMOUNT}} <span class="font-italic">{{FORM_LABELS.INCL_TAX_VAT_IF_ANY}}</span></div>
          <div>{{filteredFormData.currency}} {{filteredFormData.invoicedAmount}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.INVOICE_DATE}}</div>
          <div>{{filteredFormData.invoiceDate}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.INVOICE_REFERENCE_NUMBER}}</div>
          <div>{{filteredFormData.invoiceNumber}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.PAYMENT_DUE_DATE}}</div>
          <div>{{filteredFormData.paymentDueDate}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <div class="form-text">{{FORM_LABELS.DESCRIPTION_OF_PAYMENT}}</div>
          <div class="wrap-text">{{filteredFormData.paymentTypeDescription}}</div>
        </div>
        <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.specialInstructions">
          <div class="form-text">{{FORM_LABELS.SPECIAL_INSTRUCTIONS}}</div>
          <div class="wrap-text">{{filteredFormData.specialInstructions}}</div>
        </div>
      </div>

      <preview-form-payment-details :filteredFormData="filteredFormData" />

      <preview-attachments :filteredFormData="filteredFormData" :viewAttachment="true"/>

      <div class="pt-3">
        Please submit a copy of the
        <a href="javascript:window.print();" class="solution-link">one time vendor invoice request form</a>
        and original invoices to the respective
        Autodesk local office for the following countries for filing as required by the local Tax authorities:
        Argentina, Brazil, China, Colombia, Czech Republic, India, Israel, Italy
        , South Korea (non-digital tax Invoice or not 전자세금계산서), Mexico, Poland, Qatar, Russia, Saudi Arabia
        , Taiwan, Turkey and UAE
      </div>


      <div class="col-12 px-xl-0 pt-5 noprint">
        <div class="d-flex flex-column align-items-center justify-content-xl-end flex-xl-row">
          <button class="btn-container flat-btn gray-btn close-btn btn mx-2 my-3" @click="navigateToHome" :disabled="isLoading">
            Cancel
          </button>
          <button class="btn submit-btn btn-outline-info outline-flat-btn" @click="saveDraftOneTimeSupplierPaymentRequest(true)">Save Draft</button>
          <button class="btn primary-blue-btn flat-btn mt-2 mt-xl-0 ml-xl-2"
                  @click="submitOneTimeSupplierPayment(filteredFormData)" :disabled="isLoading">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from "lodash.clonedeep"
import PreviewFormPaymentDetails from "@/components/Payments/PaymentDetailsForm/PreviewFormPaymentDetails";
import api from "@/api";
import { mapMutations } from "vuex"
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import CONSTANTS from "@/store/constants";
import PreviewAttachments from "@/components/Payments/PreviewAttachments";

export default {
  name: "PreviewOneTimeSupplierPayment",
  props: {
    formData: String
  },
  mixins: [PaymentFormsMixin],
  components: {PreviewFormPaymentDetails, PreviewAttachments},
  data() {
    return {
      componentKey: 0,
      filteredFormData: {},
      countryPreview: '',
      formattedState: ''
    }
  },
  mounted() {
    this.filterDataForPreviewAndSubmit();
  },
  methods: {
    ...mapMutations(["setIsLoading","setFormattedInvoices"]),
    filterDataForPreviewAndSubmit() {
      this.filteredFormData = cloneDeep(this.$store.getters[this.formData])
      this.countryPreview = this.filteredFormData.country
      let countryStateObject = this.filteredFormData.region ? this.adminDataList.countryStateList.find(item => item.countryName === this.countryPreview && item.region === this.filteredFormData.region) : undefined
      this.formattedState = countryStateObject ? countryStateObject.regionName : ""
      this.filteredFormData.country = this.adminDataList.countryList.find(countryCode => countryCode.text === this.filteredFormData.country).value
      this.filteredFormData.currency = this.getTextValue(this.adminDataList.currencyList, this.filteredFormData.currency)
      this.filteredFormData.paymentType = this.getTextValue(this.adminDataList.paymentTypeOptions, this.filteredFormData.paymentType)

      //set requesterEmail to current user email
      this.filteredFormData.requesterEmail = this.currentUser.email

      //Deleting formType and attachmentUrl properties when trying to submit after editing a draft
      delete this.filteredFormData.formType;
      delete this.filteredFormData.attachmentUrl;

      this.componentKey++
    },
    async submitOneTimeSupplierPayment(formData) {
      formData = this.removeAttachmentFileSizes(formData)
      this.setIsLoading(true)
      this.setFormValidationErrors([])
      this.setIsFormDataLoaded(false)

      try {
        const resp = await api.submitOneTimeSupplierPaymentFormData(formData)
        let returnMessages = resp.data.data.submitOnetimePayment.webformResponse.returnMessages
        if(returnMessages && returnMessages.length > 0) {
          let statusId = returnMessages[0].messageId
          let webformSubmissionStatus = await this.getSupplierSubmissionStatusById(statusId)
          if (webformSubmissionStatus && webformSubmissionStatus.status === CONSTANTS.WEBFORM_SUBMISSION_STATUS.SUBMITTED) {
            let userMessages = this.buildMessageString(webformSubmissionStatus)
            this.launchSuccessModal(userMessages, 'Supplier Central - One time supplier Payment form submit success')
            this.setIsInvoicesAndDraftsCached(true)
          } else if (webformSubmissionStatus && webformSubmissionStatus.status === CONSTANTS.WEBFORM_SUBMISSION_STATUS.FAILED) {
            this.setFormValidationErrors(webformSubmissionStatus.responseMessages)
            this.setIsFormDataLoaded(true)
            this.validateAndSetCurrentTab('OneTimeSupplierPaymentQuestionnaire')
            //Reset invoices dashboard to re-fetch tracker data
            this.setFormattedInvoices([])
          } else {
            this.launchFailedModal(CONSTANTS.ERROR_MESSAGE,'Supplier Central - One time supplier Payment form api error')
          }
        }
      } catch {
        this.launchFailedModal(CONSTANTS.ERROR_MESSAGE,'Supplier Central - One time supplier Payment form api error')
      } finally {
        this.setIsLoading(false)
      }

    }
  }
}
</script>

<style>
.form-text {
  font-weight: bold;
  margin-top: 10px;
}

.title-text {
  padding: 0;
  margin: 8px 0;
}
</style>